
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export interface FuturisticCardProps {
  children: React.ReactNode;
  className?: string;
  glowColor?: 'purple' | 'cyan' | 'pink' | 'green' | 'orange';
  hoverEffect?: boolean;
  animated?: boolean;
}

export const FuturisticCard: React.FC<FuturisticCardProps> = ({
  children,
  className,
  glowColor = 'purple',
  hoverEffect = true,
  animated = true,
}) => {
  const glowColors = {
    purple: 'shadow-purple-500/25 border-purple-500/30 hover:shadow-purple-500/40',
    cyan: 'shadow-cyan-500/25 border-cyan-500/30 hover:shadow-cyan-500/40',
    pink: 'shadow-pink-500/25 border-pink-500/30 hover:shadow-pink-500/40',
    green: 'shadow-green-500/25 border-green-500/30 hover:shadow-green-500/40',
    orange: 'shadow-orange-500/25 border-orange-500/30 hover:shadow-orange-500/40',
  };

  const baseClasses = cn(
    'relative overflow-hidden rounded-xl border backdrop-blur-sm',
    'bg-gradient-to-br from-slate-900/40 to-slate-800/40',
    'transition-all duration-300',
    glowColors[glowColor],
    hoverEffect && 'hover:scale-[1.02] hover:border-opacity-50',
    className
  );

  const CardComponent = animated ? motion.div : 'div';
  const animationProps = animated ? {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3 }
  } : {};

  return (
    <CardComponent className={baseClasses} {...animationProps}>
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
      {children}
    </CardComponent>
  );
};
